export default "__VITE_ASSET__5cb9a858__"